/**
 * 环境判断
 */

const ua = window.navigator.userAgent;

// 是否微信webview
export function isWechatWebview() {
  return /MicroMessenger/i.test(ua);
}

// 是否支付宝webview
export function isAlipayWebview() {
  return /AlipayClient/i.test(ua);
}

let isWechatMiniProgramValue = /miniProgram/i.test(ua);

wx.miniProgram.getEnv(function (res: any) {
  isWechatMiniProgramValue = isWechatMiniProgramValue || res.miniprogram;
});

// 是否在小程序webview内
export function isWechatMiniProgram() {
  return isWechatMiniProgramValue;
}
